module.exports = __webpack_public_path__ + "img/la-france.d5c12041.png";